import React, { PureComponent } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import SiteCard from '../../cards/DraggableSiteCard';
import { deleteRouteSeatSite, deleteRouteSeat } from '../../../store/api/calls';

class DroppableRouteSeatListItem extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showSites: true,
      addSitesOverlay: true,
    };
  }

  toggleSites() {
    this.setState({ showSites: !this.state.showSites });
  }

  onSiteDelete(item) {
    let syncColumns = this.props.syncSiteColumns;
    let routeSeatSiteId = item.routeseatsite_id;
    let droppableId = this.props.routeSeatId;
    deleteRouteSeatSite({ routeseatsite_id: routeSeatSiteId }).then((res) => {
      syncColumns(droppableId, routeSeatSiteId);
    });
    if (this.props.onSiteDelete) this.props.onSiteDelete(this.props.routeSeatId, item.site_id);
  }

  onSeatDelete() {
    let syncColumns = this.props.syncSeatColumns;
    let routeSeatId = this.props.routeSeatId;
    let siteRouteId = this.props.siteRouteId;

    deleteRouteSeat(routeSeatId, siteRouteId).then((res) => {
      syncColumns(routeSeatId);
    });
  }

  _renderSites() {
    if (!this.state.showSites || !this.props.sites) return null;
    let sites = this.props.sites.map((item, index) => {
      item.name = item.site_name || item.name;
      return (
        <SiteCard
          key={item.site_id + '_' + index}
          index={index}
          id={item.site_id}
          draggableId={'' + item.routeseatsite_id}
          data={item}
          color={this.props.color}
          isDragDisabled={false}
          showDelete={true}
          onDeleteClick={this.onSiteDelete.bind(this, item)}
          onMouseEnter={() => {
            this.props.onMouseEnterSite(item.site_id || item.id, { cardFocused: true });
          }}
          onMouseLeave={() => {
            this.props.onMouseLeaveSite(item.site_id || item.id, {
              cardFocused: false,
              exiting: true,
            });
          }}
        />
      );
    });
    return sites;
  }

  _renderReordingIndicator() {
    return <div>{this.props.activeSeat ? 'Loading...' : null}</div>;
  }

  render() {
    let iconType = this.state.showSites ? 'fas fa-caret-down' : 'fas fa-caret-right';
    let activeSeat = this.props.activeSeat
      ? { borderColor: this.props.color, borderWidth: '.1em .1em .2em' }
      : {};

    return (
      <Droppable droppableId={`${this.props.routeSeatId}`}>
        {(provided, snapshot) => (
          <div
            className="card list-obj-inner-wrapper"
            style={activeSeat}
            index={this.props.index}
            onClick={this.props.onClick}
            onMouseEnter={this.props.onMouseEnter}
            onMouseLeave={this.props.onMouseLeave}
            key={this.props.index + this.props.item}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <div>
              <div className={'route-seat-card-header'}>
                <span style={activeSeat}>
                  {this.props.sites && this.props.sites.length ? (
                    <i
                      title="Toggle Site View"
                      className={`${iconType}`}
                      style={{ fontSize: '1em' }}
                      onClick={this.toggleSites.bind(this)}
                    />
                  ) : null}
                </span>
                <span>Sites: {this.props.sites ? this.props.sites.length : 0}</span>
                <span>
                  {this.props.sitesSelected.length ? (
                    <i
                      className="remove-seat-icon add-sites fas fa-plus-square fa-pull-right"
                      style={{ fontSize: '2em', marginTop: '.2em' }}
                      title="Add Selected Markers"
                      onClick={this.props.addRoutes}
                    />
                  ) : (
                    <i
                      className="remove-seat-icon fas fa-trash-alt fa-pull-right"
                      title="Delete Seat"
                      onClick={this.onSeatDelete.bind(this)}
                    />
                  )}
                </span>
              </div>
              {this.props.loading ? this._renderReordingIndicator() : this._renderSites()}
            </div>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    );
  }
}

export default DroppableRouteSeatListItem;
